var map = {
	"./App": 81825,
	"./App.vue": 81825,
	"./assets/IPZhiXinlogo.png": 17782,
	"./assets/images/202506031838225.png": 30664,
	"./assets/images/640.webp": 71578,
	"./assets/images/IPZhiXin.b74102e0.png": 65161,
	"./assets/images/IPZhiXin.png": 44660,
	"./assets/images/QQ.png": 74681,
	"./assets/images/about.svg": 3342,
	"./assets/images/banner.svg": 91817,
	"./assets/images/fuwu/anli101.png": 8293,
	"./assets/images/fuwu/anli102.png": 54286,
	"./assets/images/fuwu/anli103.png": 83511,
	"./assets/images/fuwu/anli201.png": 21590,
	"./assets/images/fuwu/anli202.png": 12269,
	"./assets/images/fuwu/anli203.png": 69764,
	"./assets/images/gailan/anli05.png": 61455,
	"./assets/images/gailan/anli06.png": 38996,
	"./assets/images/gailan/anli07.png": 60125,
	"./assets/images/gailan/anli09.png": 34291,
	"./assets/images/gailan/anli10.png": 49805,
	"./assets/images/gailan/susong1.png": 71104,
	"./assets/images/gailan/susong2.png": 49435,
	"./assets/images/gailan/susong3.png": 34610,
	"./assets/images/gailan/susong4.png": 39469,
	"./assets/images/gailan/图片1.png": 58510,
	"./assets/images/gailan/图片2.png": 46661,
	"./assets/images/homepage2.png": 9069,
	"./assets/images/homepageimg/1h原文.png": 12394,
	"./assets/images/homepageimg/2h原译文.png": 72010,
	"./assets/images/homepageimg/3h建议译文.png": 14954,
	"./assets/images/homepageimg/anli01.png": 64702,
	"./assets/images/homepageimg/anli02.png": 85077,
	"./assets/images/homepageimg/anli03.png": 73452,
	"./assets/images/homepageimg/company-intro.jpg": 18439,
	"./assets/images/homepageimg/fanlianli01.png": 43304,
	"./assets/images/homepageimg/fanyi1原文.png": 52207,
	"./assets/images/homepageimg/fanyi2原译文.png": 2331,
	"./assets/images/homepageimg/fanyi3建议译文.png": 76551,
	"./assets/images/homepageimg/gaikuangicon1.png": 2198,
	"./assets/images/homepageimg/gaikuangicon2.png": 16173,
	"./assets/images/homepageimg/gaikuangicon3.png": 62276,
	"./assets/images/homepageimg/gailanimg.png": 49316,
	"./assets/images/homepageimg/jianjieimg.png": 30400,
	"./assets/images/homepageimg/kehu01.png": 88991,
	"./assets/images/homepageimg/kehu02.png": 34340,
	"./assets/images/homepageimg/kehu03.png": 74285,
	"./assets/images/homepageimg/kehu04.png": 1778,
	"./assets/images/homepageimg/kehu05.png": 15995,
	"./assets/images/homepageimg/kehu06.png": 37664,
	"./assets/images/homepageimg/kehu07.png": 92489,
	"./assets/images/homepageimg/kehu08.png": 63582,
	"./assets/images/homepageimg/kehu09.png": 81895,
	"./assets/images/homepageimg/kehu10.png": 23857,
	"./assets/images/homepageimg/pinshu01.png": 85783,
	"./assets/images/homepageimg/pinshu02.png": 27676,
	"./assets/images/homepageimg/pinshu03.png": 10565,
	"./assets/images/homepageimg/pinshu04.png": 27338,
	"./assets/images/homepageimg/pinshu05.png": 82547,
	"./assets/images/homepageimg/pinshu06.png": 36792,
	"./assets/images/homepageimg/tacimg.png": 68726,
	"./assets/images/homepageimg/创意1.1.png": 41011,
	"./assets/images/homepageimg/创意1.2.png": 66520,
	"./assets/images/homepageimg/创意1.3.png": 39233,
	"./assets/images/homepageimg/创意2.1.png": 42612,
	"./assets/images/homepageimg/创意2.2.png": 47727,
	"./assets/images/homepageimg/创意2.3.png": 82534,
	"./assets/images/homepageimg/创意3.1.png": 47889,
	"./assets/images/homepageimg/创意3.11.png": 54204,
	"./assets/images/homepageimg/创意3.2.png": 17722,
	"./assets/images/homepageimg/创意3.3.png": 18947,
	"./assets/images/homepageimg/创意天地.jpg": 84202,
	"./assets/images/homepageimg/创意天地.png": 84942,
	"./assets/images/homepageimg/图片1.png": 79785,
	"./assets/images/homepageimg/德汉教材.png": 94896,
	"./assets/images/homepageimg/无效专利图1.png": 64100,
	"./assets/images/homepageimg/无效专利图2.png": 18751,
	"./assets/images/homepageimg/无效专利图3.png": 22422,
	"./assets/images/homepageimg/翻译1.png": 29254,
	"./assets/images/homepageimg/翻译2.png": 70493,
	"./assets/images/homepageimg/翻译3.png": 49364,
	"./assets/images/lianjiejpg.jpg": 75838,
	"./assets/images/map.svg": 54495,
	"./assets/images/news/hangye/anli01.png": 17979,
	"./assets/images/news/hangye/anli02.png": 39648,
	"./assets/images/news/hangye/anli03.png": 94473,
	"./assets/images/news/hangye/anli04.png": 94646,
	"./assets/images/news/hangye/anli05.png": 90975,
	"./assets/images/news/hangye/anli06.png": 36324,
	"./assets/images/news/hangye/anli07.png": 76269,
	"./assets/images/news/hangye/anli08.png": 76410,
	"./assets/images/news/hangye/anli09.png": 93987,
	"./assets/images/news/hangye/anli10.png": 68765,
	"./assets/images/news/hangye/anli11.png": 47636,
	"./assets/images/news/hangye/anli12.png": 69103,
	"./assets/images/news/hangye/anli13.png": 87558,
	"./assets/images/news/hangye/anli14.png": 89977,
	"./assets/images/news/hangye/hyn1.jpg": 30616,
	"./assets/images/news/hangye/hyn2.jpg": 9543,
	"./assets/images/news/huikui/anli01.png": 64584,
	"./assets/images/news/huikui/anli02.png": 1443,
	"./assets/images/news/huikui/anli03.png": 53690,
	"./assets/images/news/huikui/anli04.png": 77461,
	"./assets/images/news/huikui/anli05.png": 41548,
	"./assets/images/news/huikui/anli06.png": 44199,
	"./assets/images/news/huikui/anli07.png": 91710,
	"./assets/images/news/huikui/anli08.png": 37577,
	"./assets/images/news/xiaoqi/anli01.png": 38292,
	"./assets/images/news/xiaoqi/anli02.png": 12783,
	"./assets/images/news/xiaoqi/anli03.png": 73766,
	"./assets/images/news/xiaoqi/anli04.png": 23161,
	"./assets/images/news/xiaoqi/anli05.png": 16912,
	"./assets/images/news/xiaoqi/anli06.png": 88203,
	"./assets/images/news/xiaoqi/anli07.png": 67074,
	"./assets/images/news/xiaoqi/anli08.png": 61605,
	"./assets/images/news/xiaoqi/anli09.png": 78716,
	"./assets/images/news/xiaoqi/anli10.png": 89970,
	"./assets/images/s_qinquan.png": 20290,
	"./assets/images/s_shangbiao.png": 13661,
	"./assets/images/s_shangye.png": 9004,
	"./assets/images/s_zhuanli.png": 84770,
	"./assets/images/service1.svg": 48745,
	"./assets/images/service2.svg": 3930,
	"./assets/images/service3.svg": 81451,
	"./assets/images/team1.svg": 54057,
	"./assets/images/team2.svg": 9242,
	"./assets/images/team3.svg": 3115,
	"./assets/images/team4.svg": 19172,
	"./assets/images/teamimg/anli01.png": 12629,
	"./assets/images/teamimg/anli03.png": 79367,
	"./assets/images/teamimg/anli04.png": 99752,
	"./assets/images/teamimg/fanyekehu/DxO.png": 648,
	"./assets/images/teamimg/fanyekehu/FAM集团.png": 59823,
	"./assets/images/teamimg/fanyekehu/Festo.png": 2142,
	"./assets/images/teamimg/fanyekehu/GWK.png": 53422,
	"./assets/images/teamimg/fanyekehu/LAPP缆普集团.png": 17138,
	"./assets/images/teamimg/fanyekehu/Moleskine.png": 50460,
	"./assets/images/teamimg/fanyekehu/PrimaLoft.png": 35783,
	"./assets/images/teamimg/fanyekehu/WANZL旺众.png": 20490,
	"./assets/images/teamimg/fanyekehu/anli02.png": 63553,
	"./assets/images/teamimg/fanyekehu/anli03.png": 90840,
	"./assets/images/teamimg/fanyekehu/baoma.png": 86379,
	"./assets/images/teamimg/fanyekehu/万通公司.png": 79800,
	"./assets/images/teamimg/fanyekehu/佛克公司.png": 81253,
	"./assets/images/teamimg/fanyekehu/博世.png": 2219,
	"./assets/images/teamimg/fanyekehu/哈伯斯特.png": 924,
	"./assets/images/teamimg/fanyekehu/宾利汽车公司.png": 35677,
	"./assets/images/teamimg/fanyekehu/德国普旭公司.png": 94448,
	"./assets/images/teamimg/fanyekehu/曼集团.png": 383,
	"./assets/images/teamimg/fanyekehu/梅施汽车服务.png": 24162,
	"./assets/images/teamimg/fanyekehu/简森集团.png": 80501,
	"./assets/images/teamimg/fanyekehu/西克集团.png": 65325,
	"./assets/images/teamimg/fanyekehu/谷歌公司.png": 72558,
	"./assets/images/teamimg/fanyekehu/费森尤斯医疗.png": 11543,
	"./assets/images/teamimg/fanyekehu/通快集团.png": 30594,
	"./assets/images/teamimg/fanyekehu/锋翔科技.png": 30041,
	"./assets/images/teamimg/fanyekehu/隐适美.png": 54595,
	"./assets/images/teamimg/fanyiimg.png": 3806,
	"./assets/images/teamimg/hexin.png": 93020,
	"./assets/images/teamimg/icons/foreign-icon.png": 94099,
	"./assets/images/teamimg/icons/patent-icon.png": 78169,
	"./assets/images/teamimg/icons/process-icon.png": 922,
	"./assets/images/teamimg/icons/translation-icon.png": 50144,
	"./assets/images/teamimg/liuchengimg.png": 46984,
	"./assets/images/teamimg/shangbiao/11.jpg": 95485,
	"./assets/images/teamimg/shangbiao/12.jpg": 85586,
	"./assets/images/teamimg/shangbiao/21.jpg": 83284,
	"./assets/images/teamimg/shangbiao/22.jpg": 29347,
	"./assets/images/teamimg/shangbiao/23.jpg": 39238,
	"./assets/images/teamimg/shangbiao/24.jpg": 39085,
	"./assets/images/teamimg/shangbiao/25.jpg": 94192,
	"./assets/images/teamimg/shangbiao/26.jpg": 77919,
	"./assets/images/teamimg/shangbiao/anli01.png": 14430,
	"./assets/images/teamimg/shangbiao/anli02.png": 34805,
	"./assets/images/teamimg/shangbiao/anli03.png": 23180,
	"./assets/images/teamimg/shangbiao/anli04.png": 72579,
	"./assets/images/teamimg/shangbiao/anli05.png": 82746,
	"./assets/images/teamimg/shangbiao/anli06.png": 42641,
	"./assets/images/teamimg/shangbiao/anli07.png": 10600,
	"./assets/images/teamimg/shangbiaoteam.png": 92405,
	"./assets/images/teamimg/shewaiimg.png": 74126,
	"./assets/images/teamimg/teamhomebg.png": 29359,
	"./assets/images/teamimg/zhuanliimg.png": 68224,
	"./assets/images/tellphone.png": 39120,
	"./assets/images/wenjpg.png": 47868,
	"./assets/images/zhuanye.png": 28851,
	"./assets/images/右箭头.png": 41867,
	"./assets/images/图片1.png": 54653,
	"./assets/images/图片2.png": 73446,
	"./assets/images/图片3.png": 12463,
	"./assets/images/左箭头.png": 89322,
	"./assets/logo.png": 33153,
	"./components/Footer": 68867,
	"./components/Footer.vue": 68867,
	"./components/Header": 46651,
	"./components/Header copy": 59958,
	"./components/Header copy 2": 13297,
	"./components/Header copy 2.vue": 13297,
	"./components/Header copy 3": 65337,
	"./components/Header copy 3.vue": 65337,
	"./components/Header copy 4": 38908,
	"./components/Header copy 4.vue": 38908,
	"./components/Header copy.vue": 59958,
	"./components/Header.vue": 46651,
	"./components/OnlineService": 44156,
	"./components/OnlineService.vue": 44156,
	"./components/OverviewShowcaseGroup": 71400,
	"./components/OverviewShowcaseGroup copy": 89075,
	"./components/OverviewShowcaseGroup copy.vue": 89075,
	"./components/OverviewShowcaseGroup.vue": 71400,
	"./components/ShowcaseSection": 4169,
	"./components/ShowcaseSection.vue": 4169,
	"./directives/clickOutside": 30999,
	"./directives/clickOutside.js": 30999,
	"./i18n": 58044,
	"./i18n/": 58044,
	"./i18n/README": 96128,
	"./i18n/README.js": 96128,
	"./i18n/index": 58044,
	"./i18n/index.js": 58044,
	"./i18n/locales/de": 47181,
	"./i18n/locales/de.js": 47181,
	"./i18n/locales/en": 87445,
	"./i18n/locales/en.js": 87445,
	"./i18n/locales/zh": 22164,
	"./i18n/locales/zh.js": 22164,
	"./main": 51406,
	"./main.js": 51406,
	"./router": 39325,
	"./router/": 39325,
	"./router/index": 39325,
	"./router/index.js": 39325,
	"./views/Contact": 80951,
	"./views/Contact.vue": 80951,
	"./views/ExpertiseAreas": 47522,
	"./views/ExpertiseAreas.vue": 47522,
	"./views/HangYeNews": 91845,
	"./views/HangYeNews.vue": 91845,
	"./views/HomePage": 87697,
	"./views/HomePage.vue": 87697,
	"./views/HuiKuiNews": 25944,
	"./views/HuiKuiNews.vue": 25944,
	"./views/News": 52480,
	"./views/News.vue": 52480,
	"./views/Overview": 2992,
	"./views/Overview.vue": 2992,
	"./views/PracticeAreas": 80746,
	"./views/PracticeAreas.vue": 80746,
	"./views/Team": 89107,
	"./views/Team.vue": 89107,
	"./views/XiaoQiNews": 93886,
	"./views/XiaoQiNews.vue": 93886,
	"./views/teamUserDetail": 86619,
	"./views/teamUserDetail.vue": 86619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;